import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import { GetSendOwnerInviteTemplateResponseTO } from 'models/Owner';
import API from 'services/API';

export const SEND_OWNER_INVITE_BASE_QUERY_KEY = 'owners-template-invite';

type ReactQueryOptions = Omit<
  UseQueryOptions<GetSendOwnerInviteTemplateResponseTO>,
  'queryKey' | 'queryFn'
>;

type UseFetchSendOwnerInviteTemplateArgs = {
  ownerUid: string;
} & ReactQueryOptions;

const useFetchSendOwnerInviteTemplate = ({
  ownerUid,
  enabled = true,
  ...options
}: UseFetchSendOwnerInviteTemplateArgs) => {
  return useAppQuery<GetSendOwnerInviteTemplateResponseTO>({
    queryKey: [SEND_OWNER_INVITE_BASE_QUERY_KEY, 'detail', ownerUid],
    queryFn: async () => {
      const response = await API.get<GetSendOwnerInviteTemplateResponseTO>(
        '/inner-api/template_get.jsp',
        { params: { type: 'INVITE_UNACTIVE_OWNER', fill: 'true', ownerUid } },
      );

      return response.data;
    },
    enabled,
    staleTime: 30000,
    keepPreviousData: true,
    ...(options ?? {}),
  });
};

export default useFetchSendOwnerInviteTemplate;
